// Angular
import { Component, Input, Output, EventEmitter, AfterContentInit } from '@angular/core';
import { OnChanges } from '@angular/core';
import { ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Renderer2, SimpleChange } from '@angular/core';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';

// Rx
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { interval } from 'rxjs';

// Services
import { AuthService } from 'app/_services';

// Model
import { Tile } from 'app/_models';

// 3rd party
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tile',
  templateUrl: './tile.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Default
})
export class TileComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit {
  @ViewChild('tileElement', { static: false }) tileElement: ElementRef;

  @Input() settings: Tile;
  @Output() update: EventEmitter<any> = new EventEmitter<any>();

  private toastr: any;
  private subscription: Subscription;

  public statsOverview: any = [];

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private authService: AuthService,
    private toastrService: ToastrService,
  ) {
  }

  public btnClick(): void {
    this.update.emit('update');
  }

  public isMultiple(): boolean {
    return this.settings.KPIs && this.settings.KPIs.length > 0;
  }

  public columnWidth(): number {
    return Math.round(12 / this.settings.KPIs.length);
  }

  public getKPIData(): void {
    let join = [];
    let dataTotal;
    let dataToday;

    this.toastr = this.toastrService.success('Loading KPI: ' + this.settings.Title);

    if (this.settings.KPIs && this.settings.KPIs.length > 0) {
      join = [];

      for (const KPI of this.settings.KPIs) {
        if (KPI.Service) {
          join.push(KPI['Service'].GetKPIData(KPI.Url));
        } else {
          join.push(this.settings['Service'].GetKPIData(KPI.Url));
        }
        this.statsOverview.push(0);
      }
    } else {
      dataTotal = this.settings['Service'].GetKPIData(this.settings.TotalUrl);
      dataToday = this.settings.TodayUrl.length > 0 ? this.settings['Service'].GetKPIData(this.settings.TodayUrl) : '';

      join = dataToday === '' ? [dataTotal] : [dataTotal, dataToday];
    }

    forkJoin(join)
      .subscribe((results: any[]) => {
        this.statsOverview = [];

        if (this.toastr && this.toastr.toastId) {
          this.toastrService.clear(this.toastr.toastId);
        }

        results.forEach(result => {
          let cnt = 0;

          if (result.length > 0) {
            cnt = result[0].Count ? result[0].Count : 0;
          } else if (result.length === 0) {
            cnt = 0;
          }

          this.statsOverview.push(cnt);
        });
      });
  }

  public navigateTo(GoTo: any = '/dashboard'): void {
    console.log('TileComponent: jumpTo');

    if (GoTo.target && GoTo.target === '_self') {
      this.router.navigate([GoTo.url]);
    } else if (GoTo.url && GoTo.url.indexOf('https') === 0) {
      setTimeout(() => {
        if (GoTo.login) {
          const authenticationProvider = this.authService.getAuthenticationProvider();

          GoTo.url = GoTo.url + '&authenticationProvider=' + authenticationProvider;
        }

        const link = document.createElement('a');

        link.target = GoTo.target ? GoTo.target : '_blank';
        link.href = GoTo.url;
        link.setAttribute('visibility', 'hidden');
        document.body.appendChild(link);
        link.click();
        link.remove();
      }, 200);
    } else {
      this.router.navigate([GoTo.url]);
    }
  }

  ngAfterContentInit() {
  }

  ngOnInit() {
    this.renderer.addClass(this.tileElement.nativeElement, this.settings.Color);

    this.getKPIData();

    const source = interval(4 * 60 * 1000);
    this.subscription = source.subscribe(val => this.getKPIData());
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.settings) {
      if (changes.settings.currentValue && changes.settings.currentValue.length > 0) {
        this.settings = changes.settings.currentValue;
      }
    }
  }

  ngOnDestroy() {
    console.log('TileComponent: ngOnDestroy');

    this.subscription.unsubscribe();
  }
}
